/** Created by azhou on 2019/3/19.*/
<template>
  <div>
    <public-title>{{brand ? '活动' : '门票'}}列表
      <el-button slot="right" class="ml-auto" size="small" type="success" @click="addTicket">添加{{brand ? '活动' : '门票'}}</el-button>
      <div slot="right" class="text-right text-link ml-4" v-if="isGroup" @click="$router.back()">返回列表</div>
    </public-title>
    <div class="load-area">
      <el-tabs v-if="brand" v-model="activeName" @tab-click="status= activeName == 'all' ? '' : activeName;getStoreTicketLists({page:1,status})">
        <el-tab-pane :name="item.id" v-for="item in mealArr" :key="item.id" :label="item.name" />
      </el-tabs>
      <product-calendar v-if="activeName==2 && brand" />
      <div v-else class="p-4">
        <p v-if="StoreTicketList.total<=0">当前没有数据</p>
        <div v-else>
          <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
          <ul class="list-item" v-for="item in StoreTicketList.lists" :key="item.id">
            <li class="w-50 list-item-col" v-if="brand">{{item.name}}</li>
            <li class="w-50 list-item-col" v-else>{{item.ticket_type == 1 ? '团队票' : '散客票'}}</li>
            <li class="w-50 list-item-col">{{(item.ticket_species || item.species) | formatVar('ticketTypeArr')}}</li>
            <li class="w-50 list-item-col" v-if="brand">{{item.create_time | formatTimestamp(1)}}</li>
            <li class="w-50 list-item-col" v-else>{{item.name}}</li>
            <li class="w-50 list-item-col flex-column">
              <label class="text-muted">门市价：<span class="text-blue">&yen;{{item.price1}}</span>
                <span v-if="brand">/&yen;{{item.price01}}</span>
              </label>
              <label class="text-muted" v-if="Number(item.price2) > 0">{{brand ? '采购商价' : '网络价'}}：
                <span class="text-blue">&yen;{{item.price2}}</span><span v-if="brand">/&yen;{{item.price02}}</span>
              </label>
              <label class="text-muted">{{brand ? '订单雨价' : '采购商价'}}：
                <span class="text-blue">&yen;{{item.price3}}</span><span v-if="brand">/&yen;{{item.price03}}</span>
              </label>
            </li>
            <li class="w-50 list-item-col">
              <label v-if="brand" :class="item.status == 0 ? 'text-danger' : 'text-success'">
                {{item.status == 1 ? '启用中' : '已下架'}}
                <span class="text-link" @click="changeStatus(item)">（{{item.status == 1 ? '下架' : '上架'}}）</span>
              </label>
              <span v-else :class="item.is_verify == 0 ? 'text-danger' : 'text-success'">
                {{item.is_verify == 0 ? '待审核' : '已审核'}}
              </span>
            </li>
            <li class="w-50 list-item-col-end">
              <span class="text-link mr-2" @click="editTicket(item)">编辑</span>
              <span class="text-link" @click="deleteTicket(item)">删除</span>
            </li>
          </ul>
          <el-pagination background layout="prev, pager, next" class="mt-4"
                        :total="StoreTicketList.total" :current-page.sync="currentPage"
                        @current-change="v => getStoreTicketLists({page:v,status})"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'
  import ProductCalendar from '../../Admin/VocationProductManage/ProductCalendar.vue'

  export default {
    name: 'TicketLists',
    components: {ProductCalendar},
    computed: {
      ...mapState(['StoreTicketList']),
      ...mapGetters(['storeInfo','isGroup','brand']),
      queryCon() { return this.$route.query },
      titleArr () {
        let arr = ['门票类型','票种','产品名称','价格','状态','操作']
        if (this.brand) arr = ['产品名称','票种','添加时间','价格','状态','操作']
        return arr
      }
    },
    data() {
      return {
        currentPage:1,
        status: '',
        activeName:'all',
        mealArr: [{id:'all',name:'全部'},{id:'1',name:'已上架'},{id:'0',name:'已下架'},{id:'2',name:'活动日历'}],
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.store})
      this.getStoreTicketLists({page:this.currentPage,status});
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getStoreTicketLists','deleteStoreTicket','setStoreTicket','addEditTicket']),
      changeStatus (item) {
        this._confirm(`确定将该活动${item.status ? '下架' : '上架'}么？`,() => {
          item.onsale_id = item.id; delete item.id
          this.addEditTicket({...item,status: item.status == 1 ? '0' : '1'})
          this.currentPage = 1; this.activeName = 'all'; 
        })
      },
      //添加门票
      addTicket() {
        if (!this.$GFUN.powerIsInArray([440,593])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addEditTicket',query:{store:this.queryCon.id}})
      },
      //删除门票
      deleteTicket(item) {
        if (!this.$GFUN.powerIsInArray([442,595])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('确认删除么？',() => { this.deleteStoreTicket(item.id) });
      },
      //编辑门票
      editTicket(item) {
        if (!this.$GFUN.powerIsInArray([441,594])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addEditTicket',query:{store:this.queryCon.id,id:item.id}})
      }
    },
  }
</script>
